import React, { useState } from 'react';
import TextField from '@material-ui/core/TextField';
import { makeStyles } from "@material-ui/core/styles";
import ButtonBase from '../../../components/Buttons/ButtonBase';
import IconButton from '@material-ui/core/IconButton';
import InputAdornment from '@material-ui/core/InputAdornment';
import Visibility from '@material-ui/icons/Visibility';
import VisibilityOff from '@material-ui/icons/VisibilityOff';
import { Link } from 'react-router-dom';

const useStyles = makeStyles(theme => ({
    colorGrayIcon: {
        color: '#c1c1c1',
        padding: 0
    },
    TextField: {
        maxWidth: '336px',
        height: 74
    },
}));
 
const InfoClient = (props) => {
    const {
        values:{name,lastName, phone}
        ,handleSubmit,handleChange,
        touched,dirty,handleBlur,errors,isValid,
    } = props;
    const classes = useStyles();
   

    return ( 
        <div 
            style={{
                display:'flex',    
                flexDirection: 'column',
                width: '100%',
                alignItems: 'center'
            }}
        >
            <TextField
                label="Nombre"
                type="text"
                id="name"
                variant="outlined"
                classes={{ root: classes.TextField }}
                onBlur={handleBlur}
                onChange={handleChange}
                value={name}
                helperText={touched.name && errors.name ? errors.name : ''}
                error={touched.name && errors.name ? true : false}
            />

            <TextField
                label="Apellido"
                type="text"
                id="lastName"
                variant="outlined"
                classes={{ root: classes.TextField }}
                onBlur={handleBlur}
                onChange={handleChange}
                value={lastName}
                helperText={touched.lastName && errors.lastName ? errors.lastName : ''}
                error={touched.lastName && errors.lastName ? true : false}
            />

            <TextField
                label="Número telefónico"
                type="text"
                id="phone"
                variant="outlined"
                classes={{ root: classes.TextField }}
                onBlur={handleBlur}
                onChange={handleChange}
                value={phone}
                helperText={touched.phone && errors.phone ? errors.phone : ''}
                error={touched.phone && errors.phone ? true : false}
            />

            <div className="horizontal-layout" style={{ marginTop: 32 }}>
                <ButtonBase
                    type="submit"
                    onClick={handleSubmit}
                    variant="primary"
                    disabled={!isValid}
                >
                    Continuar
                </ButtonBase>
            </div>        
        </div>
    );
}
 
export default InfoClient;